import { logoutUser } from '@goldcast/api/backend';
import { Auth } from 'aws-amplify';

import { deleteAllCookies, clearAllTokensFromLocalStorage } from './cookies';
import { stopSessionValidationPolling } from './magicLinkAuth';

import { GCAuth, GCAUTH_ACCESS_TOKEN_KEY } from '@/services/gcauth.service';
import { getValueFromLocalstore } from '@/services/localStorage.service';
import loggerService from '@/services/logger.service';
import store from '@/store';

export async function authSignOut() {
  stopSessionValidationPolling();

  const userHasAccessToken = !!store.state.user?.accessToken;
  const useGCAuth = store.state.event.useGCAuth;

  return (
    userHasAccessToken
      ? logoutUser({}).catch(err => {
          loggerService.error(err);
          return Promise.resolve();
        })
      : Promise.resolve()
  )
    .then(() => {
      if (useGCAuth) {
        const accessToken = store.state.user?.accessToken ?? getValueFromLocalstore(GCAUTH_ACCESS_TOKEN_KEY);
        if (accessToken) {
          return GCAuth.signOut(accessToken);
        }
        return;
      }
      return Auth.signOut({ global: true });
    })
    .catch(err => {
      if (useGCAuth) {
        loggerService.warn('GCAuth signOut failed: ', err);
        return;
      }
      // When the users access token has been revoked
      // global signout does not work. Cognito suggests to do
      // a normal signout when global signout fails due to invalid
      // tokens:
      // https://github.com/aws-amplify/amplify-js/issues/3540
      //
      // Amplify auth library only tries to fetch the user details when the
      // user logouts when global signout is enabled:
      // https://github.com/aws-amplify/amplify-js/blob/c58d1e6b5cdc996c28770ef56d561006b43d5579/packages/auth/src/Auth.ts#L2075
      if (err.message === 'Access Token has been revoked') {
        return Auth.signOut();
      }

      throw err;
    });
}

export async function safeSignout() {
  return authSignOut()
    .catch(err => {
      loggerService.warn('Error when trying to signout: ', err);
    })
    .finally(() => {
      deleteAllCookies();
      clearAllTokensFromLocalStorage();
    });
}
